import { Skeleton } from './skeleton';

type LoadingStateProps = {
  label?: string;
  rows?: number;
};

export default function LoadingState({ label = 'Loading…', rows = 3 }: LoadingStateProps) {
  return (
    <div className="space-y-3" role="status" aria-live="polite">
      <p className="text-sm text-muted-foreground">{label}</p>
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className={i === 0 ? 'h-24 w-full' : 'h-16 w-full'} />
      ))}
    </div>
  );
}
